/**
 * The single letter an Avatar falls back to when there is no image. Prefers the
 * display name, then the email, so a member with no name still gets an initial
 * rather than a blank circle.
 */
export function avatarLetter(name: string, email: string): string {
  const source = name.trim() || email.trim();
  return source ? source.charAt(0).toUpperCase() : '·';
}
